var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg48IconRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-641 -352.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "translate(641 352.5)",
    fill: "#f4f3f0",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-345 -350.794)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(356 361.795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2,2.6A10.4,10.4,0,1,0,23.6,13,10.411,10.411,0,0,0,13.2,2.6m0-2.6A13,13,0,1,1,.2,13,13,13,0,0,1,13.2,0Z",
    transform: "translate(-0.2 -0.001)",
    fill: "#816920"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,9.1H1.3a1.3,1.3,0,0,1,0-2.6H6.5V1.3a1.3,1.3,0,1,1,2.6,0V7.8A1.3,1.3,0,0,1,7.8,9.1Z",
    transform: "translate(361.233 375) rotate(-45)",
    fill: "#816920"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg48IconRightArrow);
export default __webpack_public_path__ + "static/media/48-icon-rightArrow.3756491a.svg";
export { ForwardRef as ReactComponent };